import { jsxs as E, jsx as r } from "react/jsx-runtime";
import { useContext as I, useState as a, useEffect as S } from "react";
import { useDropzone as b } from "react-dropzone";
import g from "classnames";
import "../../components/Breadcrumbs/index.js";
import "../../components/Button/index.js";
import "reactjs-popup";
import { ThemeContext as G } from "../../components/ThemeContext/index.js";
import "../../components/Modal/index.js";
import "../FieldContainer/index.js";
import "../Checkbox/index.js";
import "../ContentEditable/index.js";
import "../DateInput/index.js";
import "date-fns";
import "react-i18next";
import "../../index-YV3Z4nmr.js";
import "../Input/index.js";
import "react-dom";
import "../InputTooltip/index.js";
import "../PhoneInput/index.js";
import "../SocialSelect/index.js";
import "../Switcher/index.js";
import "../Textarea/index.js";
import "react-hook-form";
import "sanitize-html";
import "i18next";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "react-number-format";
import "immutability-helper";
import "../../components/Tooltip/index.js";
import T from "./FileDropzoneFileSingle/index.js";
import q from "./FileDropzoneFilesList/index.js";
import w from "./FileDropzoneFilesGrid/index.js";
import B from "./FileDropzoneContent/index.js";
const J = "forma-ui__file-dropzone__root", K = "forma-ui__file-dropzone__empty", O = "forma-ui__file-dropzone__hover", Q = "forma-ui__file-dropzone__accepted", U = "forma-ui__file-dropzone__rejected", V = "forma-ui__file-dropzone__files", t = {
  root: J,
  empty: K,
  hover: O,
  accepted: Q,
  rejected: U,
  files: V
}, W = 1024 * 1024 * 1, Mo = ({
  title: j,
  placeholder: C,
  accept: u,
  maxFiles: e = 1,
  maxSize: _ = W,
  previews: h,
  onChange: R,
  className: y,
  contentClassName: A
}) => {
  const { viewport: k } = I(G), [v, z] = a(!1), [L, N] = a(!1), [o, m] = a([]), F = k === "phone", { getRootProps: H, getInputProps: M, open: c, isFocused: D, isDragActive: p, isDragAccept: l, isDragReject: d } = b({
    maxFiles: e,
    noClick: !0,
    accept: u,
    multiple: e > 1,
    onDrop: (s) => {
      m(e === 1 ? s : (i) => [
        ...i,
        ...s.filter((n) => !i.find((P) => P.name === n.name) && n.size <= _).splice(0, e - i.length)
      ]);
    }
  });
  S(() => {
    L ? R(o) : N(!0);
  }, [o]);
  const f = (s) => {
    m((i) => {
      const n = [...i];
      return n.splice(s, 1), n;
    });
  };
  return /* @__PURE__ */ E(
    "div",
    {
      className: g(
        t.root,
        (v || D) && t.hover,
        p && t.active,
        l && t.accepted,
        d && t.rejected,
        o != null && o.length ? t.filled : t.empty,
        y
      ),
      onMouseEnter: () => z(!0),
      onMouseLeave: () => z(!1),
      ...H(),
      children: [
        /* @__PURE__ */ r("input", { ...M() }),
        o.length && !(l || p || d) ? /* @__PURE__ */ r("div", { className: g(t.files, "styled-scrollbar"), children: h ? /* @__PURE__ */ r(
          w,
          {
            files: o,
            onRemove: f,
            columns: h.columns,
            maxFiles: e,
            onClickAdd: c
          }
        ) : e > 1 ? /* @__PURE__ */ r(
          q,
          {
            files: o,
            onRemove: f,
            onClickAdd: c,
            maxFiles: e
          }
        ) : /* @__PURE__ */ r(
          T,
          {
            name: o[0].name,
            path: o[0].path,
            onRemove: () => f(0)
          }
        ) }) : /* @__PURE__ */ r(
          B,
          {
            isPhone: F,
            isHovered: v || D,
            isDragAccept: p || l,
            isDragReject: p && d,
            title: j,
            placeholder: C,
            maxSize: _,
            maxFiles: e,
            accept: u,
            onClickAdd: c,
            className: A
          }
        )
      ]
    }
  );
};
export {
  Mo as default
};
